<template>
	<b-container fluid class="rb-account">
		<b-row>
			<b-col xl="8" offset-xl="2" lg="10" offset-lg="1" class="my-5">


				<b-row>
					<b-col cols="6">

						<b-row>
							<b-col cols="4" offset="4">
								<rb-avatar class="my-avatar" />
							</b-col>
						</b-row>

						<b-row v-if="loggedUser">
							<b-col cols="12" class="text-center my-4">
								<h2>
									{{ loggedUser.Name }}
								</h2>
								<small> {{loggedUser.Email}} </small>
							</b-col>

							<b-col cols="12" class="text-center">
								<h2
									:class="{
										'text-danger': loggedUser.Status === 0,
										'text-success': loggedUser.Status > 0
									}"
								>
									<span v-if="loggedUser.Status === 0">Usuário Normal</span>
									<span v-if="loggedUser.Status === 1">FIRST</span>
									<span v-if="loggedUser.Status === 2">Doador</span>
									<span v-if="loggedUser.Status === 3">Administrador</span>
								</h2>

								<h4 v-if="loggedUser.Status === 2">
									Válido até {{ loggedUser.SubscriptionEnd.format('d/m/Y') }}
								</h4>
							</b-col>
						</b-row>

					</b-col>

					<b-col cols="6">
						<rb-loader center v-if="!loaded"></rb-loader>

						<template v-if="loaded && loggedUser">
							<h2 class="text-center mb-4">
								Contribua já!
							</h2>

							<subscription-button
								v-for="discount in pricing.Discounts"
								:key="discount.Months"

								:months="discount.Months"
								:discount="discount.Discount"
								:price="discount.Months * pricing.Month"

								class="mb-3"
							/>
						</template>

						<template v-if="loaded && !loggedUser">
							<h2 class="text-center mb-4">
								Primeiramente faça o login com o facebook
							</h2>
						</template>
					</b-col>
				</b-row>


				<b-row v-if="purchases.length">
					<b-col>
						<h3>Histórico de pagamentos</h3>

						<div class="purchase-box" v-for="purchase in purchases" :key="purchase.Id">
							<div class="float-right text-right">
								<b>
									{{purchase.GrossAmount.pad(0,2)}} R$
								</b>
								<br>
								<i>
									{{ purchase.Date.format('d/m/Y H:i:s') }}
								</i>
							</div>

							<b style="font-size: 1.1em">
								{{ purchase.Months }} {{ purchase.Months > 1 ? "meses" : "mês" }}
							</b>
							<br>

							Status:
							<span>
								{{ purchase.Status.label }}
							</span>

							<a v-if="purchase.Status.value === 1" href="<?=GetActionUrl('Pagseguro', 'Update', ['id'=>$purchase->Id])?>" class="btn btn-primary">
								Forçar verificação de status
							</a>
						</div>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import SubscriptionButton from '../components/SubscriptionButton';
	import {mapState} from 'vuex';
	import RbAvatar from '../components/RbAvatar';
	import {oldApi} from '../app/oldApi';
	import RbLoader from '../components/RbLoader';
	import {Purchase} from '../../../shared/entities/Purchase';

	export default {
		name: 'Account',
		components: {RbLoader, RbAvatar, SubscriptionButton},
		metaInfo() {
			return {
				title: 'Minha Conta'
			}
		},
		data: () => ({
			loaded: false,
			pricing: null,
			purchases: []
		}),
		async mounted() {
			this.loadPricing();
			this.loadHistory();
		},
		methods: {
			async loadPricing() {
				const { data } = await oldApi.get('Donation.Pricing');

				this.pricing = data;

				this.loaded = true;
			},
			async loadHistory() {
				const { data } = await oldApi.get('Donation.History');

				this.purchases = data.map(x => new Purchase(x));
			}
		},
		computed: {
			...mapState([
				'loggedUser'
			]),
		}
	}
</script>

<style lang="scss" scoped>
	.rb-account {
		.my-avatar {
			width: 100%;
			padding: 50% 0;
		}

		.purchase-box {
			padding: 15px 5px;
			margin-bottom: 5px;
			clear: both;
			border-bottom: 1px solid rgba($light, .7);
		}
	}
</style>
